import { Swatch } from "./frame.tsx";
import type { ResolvedSeries } from "./series.ts";

/**
 * Names every series next to a swatch of its colour and pattern (or dash), with an optional
 * figure, so no series is told apart by colour alone.
 */
export function Legend({
  series,
  values,
  dashes,
}: {
  series: readonly ResolvedSeries[];
  /** A figure written after each label, e.g. its total or share. */
  values?: Readonly<Record<string, string>>;
  dashes?: readonly string[];
}) {
  return (
    <ul className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-chart-label">
      {series.map((s, i) => (
        <li key={s.key} className="flex items-center gap-1.5">
          <Swatch tone={s.tone} pattern={s.pattern} dash={dashes?.[i]} />
          <span>{s.label}</span>
          {values?.[s.key] !== undefined ? (
            <span className="tabular-nums text-fg">{values[s.key]}</span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
